import React, { ReactElement } from 'react';
import _ from 'lodash';
import { NO_DATA_TO_SHOW } from 'spw-constants';
import { asUsfOrZero } from 'spw-shared/utils';
import {
  RowWithTopMargin,
  SignColumn,
  BlackText,
  TitleText,
  OperationText,
  FlexEndColumn,
  TextColumn,
} from './styles';

interface IReadOnlyRow {
  className?: string;
  leftHeader: string | ReactElement;
  leftValue?: number | string;
  leftSign: string;
  leftSignStyle?: any;
  middleHeader: string | ReactElement;
  middleValue?: number | string;
  rightHeader: string | ReactElement;
  rightValue?: number | string;
  finalAnswer?: boolean;
  testingIdPrefix?: string;
  showDecimals: boolean;
}

const ReadOnlyRow: React.FC<IReadOnlyRow> = (props: IReadOnlyRow) => {
  const {
    className,
    leftHeader,
    leftValue,
    leftSign,
    leftSignStyle,
    middleHeader,
    middleValue,
    rightHeader,
    rightValue,
    finalAnswer,
    testingIdPrefix,
    showDecimals,
  } = props;

  let answer: string | number = NO_DATA_TO_SHOW;
  let classNameAnswer = '';
  if (!_.isNaN(rightValue) && !_.isString(rightValue)) {
    answer = asUsfOrZero(rightValue, showDecimals);
    if (finalAnswer) {
      if (rightValue < 0) classNameAnswer = 'negative';
      if (rightValue > 0) {
        answer = `+${answer}`;
        classNameAnswer = 'positive';
      }
    }
  }

  return (
    <RowWithTopMargin className={className} container>
      <FlexEndColumn item xs={3}>
        <TitleText data-testid={`${testingIdPrefix}_left_label`}>
          {leftHeader}
        </TitleText>
        <TextColumn>
          <BlackText data-testid={`${testingIdPrefix}_left_value`}>
            {leftValue}
          </BlackText>
        </TextColumn>
      </FlexEndColumn>
      <FlexEndColumn item xs={1}>
        <SignColumn className="readonly">
          <OperationText style={leftSignStyle || {}}>{leftSign}</OperationText>
        </SignColumn>
      </FlexEndColumn>
      <FlexEndColumn item xs={3}>
        <TitleText data-testid={`${testingIdPrefix}_middle_label`}>
          {middleHeader}
        </TitleText>
        <TextColumn>
          <BlackText data-testid={`${testingIdPrefix}_middle_value`}>
            {middleValue}{' '}
          </BlackText>
        </TextColumn>
      </FlexEndColumn>
      <FlexEndColumn item xs={1}>
        <SignColumn className="readonly">
          <OperationText>=</OperationText>
        </SignColumn>
      </FlexEndColumn>
      <FlexEndColumn item xs={3}>
        <TitleText data-testid={`${testingIdPrefix}_right_label`}>
          {rightHeader}
        </TitleText>
        <TextColumn>
          <BlackText
            className={classNameAnswer}
            data-testid={`${testingIdPrefix}_right_value`}
          >
            {answer}
          </BlackText>
        </TextColumn>
      </FlexEndColumn>
    </RowWithTopMargin>
  );
};

export default ReadOnlyRow;
